import {ApplicationConfig} from '@angular/core';
import {PreloadAllModules, provideRouter, withPreloading} from '@angular/router';

import {routes} from './app.routes';
import {appProviders} from "./app.providers";

export const appConfig: ApplicationConfig = {
  providers: [
    // Defaults
    provideRouter(routes, withPreloading(PreloadAllModules)),
    ...appProviders([])
  ]
};
